// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.12490"][{"8923":0}[chunkId]] || "1.12505") + "/" + chunkId + ".js";
};